export const MaintenanceScreen = () => {
  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #0f1628 0%, #16213e 50%, #1a1a2e 100%)',
      color: 'white',
      padding: 'var(--spacing-xl)',
      textAlign: 'center',
      position: 'relative',
      overflow: 'hidden'
    }}>
      {/* Patrón de fondo */}
      <div style={{
        position: 'absolute', inset: 0, opacity: 0.04,
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23f0d878' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
      }}></div>

      <div style={{
        maxWidth: 500,
        position: 'relative',
        zIndex: 1
      }}>
        {/* Logo */}
        <img
          src="/assets/icons/icon-512x512.png"
          alt="TorneosPro"
          style={{
            width: 120,
            height: 120,
            objectFit: 'contain',
            marginBottom: 'var(--spacing-xl)',
            filter: 'drop-shadow(0 0 20px rgba(240,216,120,0.3))',
            display: 'block',
            margin: '0 auto var(--spacing-xl)'
          }}
        />

        {/* Icono animado */}
        <div style={{
          fontSize: '3rem',
          color: '#f0d878',
          marginBottom: 'var(--spacing-lg)',
          animation: 'spin 3s linear infinite',
          display: 'inline-block'
        }}>
          <i className="fa-solid fa-gear"></i>
        </div>

        {/* Título */}
        <h1 style={{
          fontFamily: 'var(--font-display)',
          fontSize: 'clamp(1.8rem, 5vw, 2.8rem)',
          letterSpacing: '0.1em',
          marginBottom: 'var(--spacing-md)',
          color: 'white'
        }}>
          En mantenimiento
        </h1>

        {/* Subtítulo */}
        <p style={{
          fontSize: 'clamp(1rem, 2.5vw, 1.2rem)',
          opacity: 0.85,
          lineHeight: 1.6,
          marginBottom: 'var(--spacing-md)'
        }}>
          Estamos mejorando TorneosPro para ofrecerte una mejor experiencia.
        </p>

        <p style={{
          fontSize: '0.95rem',
          opacity: 0.6,
          lineHeight: 1.6,
          marginBottom: 'var(--spacing-2xl)'
        }}>
          Volvemos enseguida. Gracias por tu paciencia.
        </p>

        {/* Info de contacto */}
        <div style={{
          padding: 'var(--spacing-md) var(--spacing-lg)',
          background: 'rgba(240,216,120,0.08)',
          border: '1px solid rgba(240,216,120,0.2)',
          borderRadius: 'var(--radius-lg)',
          display: 'inline-block'
        }}>
          <p style={{
            fontSize: '0.85rem',
            opacity: 0.8,
            margin: 0
          }}>
            <i className="fa-solid fa-envelope" style={{marginRight: 8, color: '#f0d878'}}></i>
            ¿Urgente? Escríbenos a{' '}
            <a
              href="mailto:info@torneospro.com"
              style={{color: '#f0d878', textDecoration: 'none', fontWeight: 600}}
            >
              info@torneospro.com
            </a>
          </p>
        </div>

        {/* Footer */}
        <p style={{
          marginTop: 'var(--spacing-2xl)',
          fontSize: '0.75rem',
          opacity: 0.4
        }}>
          &copy; {new Date().getFullYear()} TorneosPro
        </p>
      </div>

      <style>{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default MaintenanceScreen;
